import React from 'react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import BookingWidget from './BookingWidget';

// Global booking dialog opened from the header "Book now" button on every page.
export const BookingDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl p-0 bg-transparent border-0 shadow-none" data-testid="booking-dialog">
      <DialogTitle className="sr-only">Booking</DialogTitle>
      {open && <BookingWidget />}
    </DialogContent>
  </Dialog>
);

export default BookingDialog;
